var generateStyle = function generateStyle(componentTheme) {
  return {
    iconWrapper: {
      display: 'flex',
      height: '100%',
      minHeight: '47px',
      width: '46px',
      justifyContent: 'center',
      alignItems: 'center',
      svg: {
        fill: 'white'
      }
    },
    collapsingTable: {
      minWidth: '500px',
      table: {
        borderCollapse: 'separate',
        borderSpacing: '0 12px'
      },
      'thead th': {
        borderWidth: '0 0 1px 0',
        borderStyle: 'solid',
        borderColor: componentTheme.colorHeaderBottomBorder
      },
      'table tbody tr td': {
        width: '33.33%',
        borderStyle: 'solid',
        borderWidth: '2px 0 2px 0'
      },
      'table tbody tr th:first-of-type': {
        borderStyle: 'solid',
        borderRadius: '4px 0 0 4px',
        borderWidth: '2px 0 2px 2px',
        fontWeight: '400'
      },
      'table tbody tr td:last-child': {
        borderStyle: 'solid',
        borderWidth: '2px 2px 2px 0',
        borderRadius: '0 4px 4px 0'
      }
    },
    onlyNoanswer: {
      'tbody tr:nth-of-type(1) td': {
        borderColor: componentTheme.colorGrey
      },
      'table tbody tr:nth-of-type(1) th': {
        borderColor: componentTheme.colorGrey
      }
    },
    correctIncorrect: {
      'table tbody tr:nth-of-type(1) td': {
        borderColor: componentTheme.colorGreen
      },
      'table tbody tr:nth-of-type(1) th': {
        borderColor: componentTheme.colorGreen
      },
      'table tbody tr:nth-of-type(2) td': {
        borderColor: componentTheme.colorRed
      },
      'table tbody tr:nth-of-type(2) th': {
        borderColor: componentTheme.colorRed
      }
    },
    correctIncorrectNoanswer: {
      'table tbody tr:nth-of-type(1) td': {
        borderColor: componentTheme.colorGreen
      },
      'table tbody tr:nth-of-type(1) th': {
        borderColor: componentTheme.colorGreen
      },
      'table tbody tr:nth-of-type(2) td': {
        borderColor: componentTheme.colorRed
      },
      'table tbody tr:nth-of-type(2) th': {
        borderColor: componentTheme.colorRed
      },
      'table tbody tr:nth-of-type(3) td': {
        borderColor: componentTheme.colorGrey
      },
      'table tbody tr:nth-of-type(3) th': {
        borderColor: componentTheme.colorGrey
      }
    },
    correctIncorrectNoanswerGraded: {
      'table tbody tr:nth-of-type(1) td': {
        borderColor: componentTheme.colorGreen
      },
      'table tbody tr:nth-of-type(1) th': {
        borderColor: componentTheme.colorGreen
      },
      'table tbody tr:nth-of-type(2) td': {
        borderColor: componentTheme.colorBlue
      },
      'table tbody tr:nth-of-type(2) th': {
        borderColor: componentTheme.colorBlue
      },
      'table tbody tr:nth-of-type(3) td': {
        borderColor: componentTheme.colorRed
      },
      'table tbody tr:nth-of-type(3) th': {
        borderColor: componentTheme.colorRed
      },
      'table tbody tr:nth-of-type(4) td': {
        borderColor: componentTheme.colorGrey
      },
      'table tbody tr:nth-of-type(4) th': {
        borderColor: componentTheme.colorGrey
      }
    },
    correctBackground: {
      backgroundColor: componentTheme.colorGreen
    },
    incorrectBackground: {
      backgroundColor: componentTheme.colorRed
    },
    gradedBackground: {
      backgroundColor: componentTheme.colorBlue
    },
    noAnswerBackground: {
      backgroundColor: componentTheme.colorGrey
    },
    labelWrapper: {
      padding: '12px 0 12px 10px'
    },
    firstHeaderCell: {
      paddingLeft: '45px'
    },
    iconWhite: {
      svg: {
        fill: 'white'
      }
    },
    headerCell: {
      borderWidth: '0 0 1px 0',
      borderStyle: 'solid',
      borderColor: componentTheme.colorHeaderBottomBorder
    }
  };
};
export default generateStyle;